import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Box,
  Modal,
  Button,
  Card,
  Heading,
  useToast,
  Grid,
  GridItem,
  Input,
  Select,
} from '@chakra-ui/react';

import xhr from 'xhr';

import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import dayjs from 'dayjs';
import BasicModal from 'components/modal/Modal';
import { EmptyState } from '../../components/ui';

export default function reminderProspect() {
  const params = useParams();
  const id_est = params.id;
  const [reminderProspect, setReminderProspect] = React.useState([]);
  const [isOpen, setIsOpen] = React.useState(false);

  function dias() {
    let diasV = [];
    for (let step = 1; diasV.length < 31; step++) {
      if (step <= 9) {
        diasV.push({
          value: `0${step}`,
          label: step,
        });
      } else {
        diasV.push({
          value: step,
          label: step,
        });
      }
    }

    return diasV;
  }

  // Antes generaba 24 opciones desde las 8 (8 a 31) y las horas 24-31 hacían
  // fallar el guardado. Se ofrecen las horas válidas de 6:00 a 22:00.
  function horas() {
    const horasV = [];
    for (let hour = 6; hour <= 22; hour++) {
      horasV.push({
        value: String(hour).padStart(2, '0'),
        label: `${hour}:00`,
      });
    }
    return horasV;
  }

  const meses = [
    {
      value: '01',
      label: 'Enero',
    },
    {
      value: '02',
      label: 'Febrero',
    },
    {
      value: '03',
      label: 'Marzo',
    },
    {
      value: '04',
      label: 'Abril',
    },
    {
      value: '05',
      label: 'Mayo',
    },
    {
      value: '06',
      label: 'Junio',
    },
    {
      value: '07',
      label: 'Julio',
    },
    {
      value: '08',
      label: 'Agosto',
    },
    {
      value: '09',
      label: 'Septiembre',
    },
    {
      value: '10',
      label: 'Octubre',
    },
    {
      value: '11',
      label: 'Noviembre',
    },
    {
      value: '12',
      label: 'Diciembre',
    },
  ];

  React.useEffect(() => {
    const getHistoryProspect = async () => {
      try {
        const res2 = await xhr(`/prospect-reminders?filters[prospect][id][$eq]=${params.id}&sort[0]=date:desc`);
        setReminderProspect(res2.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    getHistoryProspect();
  }, []);

  const BasicInfoSchema = Yup.object().shape({
    title: Yup.string().required('Requerido'),
    message: Yup.string().required('Requerido'),
  });

  const [loading, setLoading] = React.useState(false);
  const toasts = useToast();

  const handleTopic2 = async (values, action) => {
    // El formulario solo pide día y mes: se usa el año actual, o el siguiente
    // si esa fecha ya pasó, para que aparezca en "Recordatorios para hoy".
    let fechaRecordatorio = dayjs(`${dayjs().year()}-${values.mes}-${values.dia}`);
    if (fechaRecordatorio.isBefore(dayjs(), 'day')) {
      fechaRecordatorio = fechaRecordatorio.add(1, 'year');
    }
    const fecha_guar = fechaRecordatorio.format('YYYY-MM-DD');

    const hora_guar = `${values.hora}:00:00`;

    try {
      setLoading(true);

      const response = await xhr.post(`/prospect-reminders/`, {
        data: {
          ...values,
          prospect: id_est,
          date: fecha_guar,
          time: hora_guar,
        },
      });

      setReminderProspect([response.data.data, ...reminderProspect]);

      toasts({
        title: 'El recordatorio se creó correctamente',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      action.resetForm();

      setIsOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box marginBottom="15px">
        <Button size="sm" variant="outline" colorScheme="purple" onClick={() => setIsOpen(true)}>
          + Recordatorio
        </Button>
        <BasicModal isOpen={isOpen} setIsOpen={setIsOpen}>
          <Formik
            initialValues={{
              title: '',
              message: '',
              dia: '',
              mes: '',
              hora: '',
            }}
            validationSchema={BasicInfoSchema}
            onSubmit={handleTopic2}
          >
            <Form>
              <Heading as="h2" fontSize="lg" margin="0">
                Nuevo recordatorio
              </Heading>

              <Grid templateColumns="repeat(12, 1fr)" gap={5}>
                <GridItem colSpan={4}>
                  <Field marginTop="20px" name="dia" label="Día" color="black" placeholder="Día" as={Select}>
                    {dias().map((el) => (
                      <option value={el.value} key={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </Field>
                </GridItem>

                <GridItem colSpan={4}>
                  <Field marginTop="20px" name="mes" label="Mes" color="black" placeholder="Mes" as={Select}>
                    {meses.map((el) => (
                      <option value={el.value} key={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </Field>
                </GridItem>

                <GridItem colSpan={4}>
                  <Field marginTop="20px" name="hora" label="Hora" color="black" placeholder="Hora" as={Select}>
                    {horas().map((el) => (
                      <option value={el.value} key={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </Field>
                </GridItem>
              </Grid>

              <Field marginTop="20px" name="title" label="Título" color="black" placeholder="Título. Ej.: Volver a llamar" as={Input} />
              <Field marginTop="20px" name="message" label="Mensaje" color="black" placeholder="Mensaje" as={Input} />

              <Button type="submit" colorScheme="purple" marginTop="15px" width="100%" isLoading={loading}>
                Guardar recordatorio
              </Button>
            </Form>
          </Formik>
        </BasicModal>
      </Box>
      {reminderProspect.length === 0 ? (
        <EmptyState
          title="Este prospecto no tiene recordatorios"
          description="Los recordatorios del día aparecen en la pestaña «Recordatorios de hoy» del Escritorio."
        />
      ) : (
        <TableContainer>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Título</Th>
                <Th>Mensaje</Th>
                <Th textAlign="right">Fecha</Th>
              </Tr>
            </Thead>
            <Tbody>
              {reminderProspect.map((requi) => (
                <Tr key={requi.id}>
                  <Td fontWeight="600" py={3}>
                    {requi.title}
                  </Td>
                  <Td whiteSpace="pre-wrap">{requi.message}</Td>
                  <Td textAlign="right" whiteSpace="nowrap">
                    {dayjs(requi.date).format('DD/MM/YYYY')} · {requi.time ? requi.time.slice(0, 5) : ''}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
